import { createSlice } from "@reduxjs/toolkit";
import { AibleClientFactory } from "client/aible/factory";
import * as accountsReducer from "containers/Accounts/reducer";
const initialState = {
    profiler: undefined
};
const agentSlice = createSlice({
    name: "agent",
    initialState,
    reducers: {
        updateProfiler(state, { payload }) {
            return {
                ...state,
                profiler: payload
            };
        },
        updateProfilerResults(state, { payload }) {
            if (!state.profiler)
                return state;
            return {
                profiler: {
                    ...state.profiler,
                    results: payload
                }
            };
        },
        updateProfilerStatus(state, { payload }) {
            if (!state.profiler)
                return state;
            return {
                profiler: {
                    ...state.profiler,
                    profile_status: payload
                }
            };
        }
    }
});
export default agentSlice.reducer;
export const getAgentState = (state) => state.agent;
export const getAgentProfiler = (state) => getAgentState(state).profiler;
export const createAgentProfiler = (options) => {
    return async (dispatch, getState) => {
        const accountId = accountsReducer.getSelectedAccountId(getState());
        const clientFactory = AibleClientFactory.getInstance();
        const accountClient = clientFactory.getAccountClient();
        const factory = await accountClient.getCustomerClientFactory(accountId);
        const response = await factory.getAgentClient().createAgentProfiler(options);
        dispatch(agentSlice.actions.updateProfiler(response));
        return response;
    };
};
export const getAgentProfilerStatus = (profilerId) => {
    return async (dispatch, getState) => {
        const state = getState();
        const accountId = accountsReducer.getSelectedAccountId(state);
        const clientFactory = AibleClientFactory.getInstance();
        const accountClient = clientFactory.getAccountClient();
        const factory = await accountClient.getCustomerClientFactory(accountId);
        const response = await factory.getAgentClient().getAgentProfilerStatus(profilerId);
        // Update the profiler status in the state
        dispatch(agentSlice.actions.updateProfilerStatus(response.profile_status));
        return response;
    };
};
export const getAgentProfilerResults = (profilerId) => {
    return async (dispatch, getState) => {
        const state = getState();
        const accountId = accountsReducer.getSelectedAccountId(state);
        const clientFactory = AibleClientFactory.getInstance();
        const accountClient = clientFactory.getAccountClient();
        const factory = await accountClient.getCustomerClientFactory(accountId);
        const results = await factory.getAgentClient().getAgentProfilerResults(profilerId);
        // Update the profiler results in the state
        dispatch(agentSlice.actions.updateProfilerResults(results));
        return results;
    };
};
